import { CSRF_COOKIE_NAME } from "./csrfCookieName";

export const getCurrentCsrfCookie = (): string | undefined => {
  const cookies = document.cookie.split(';');
    const csrfCookie = cookies.find(cookie => 
      cookie.trim().startsWith(CSRF_COOKIE_NAME)
    );
  return csrfCookie?.split('=')[1];
};